import * as Yup from "yup";

const newProductCommonData = {
  name: Yup.string().required("Product Name is Required"),
  // sale_ok: Yup.boolean().required("required"),
  // purchase_ok: Yup.boolean().required("required"),
};

export const newProductVTEXFormValidationSchema = Yup.object({
  ...newProductCommonData,
  VtexBrand: Yup.number()
    .positive("Brand Id Must be a positive Number")
    .required("Brand Id required"),
  public_categ_ids: Yup.array()
    .min(1, "Category is required")
    .required("Category is required"),

  description_sale: Yup.string().required("Product Description is Required"),
  // description_sale: Yup.string()
  //   .transform((value) => (value === false ? "" : value))
  //   .required("Product Description is Required"),
  alternative_product_ids: Yup.array().of(Yup.number()),
});
export const newProductGeneralFormValidationSchema = Yup.object({
  ...newProductCommonData,
  // categ_id: Yup.number().required("Category is required"),
  list_price: Yup.number()

    .min(0, "Must be greater or equal to 0")
    .max(999, "Must be less than or equal to 999"),
  taxes_id: Yup.array().of(Yup.number()),
  standard_price: Yup.number()
    .required("Product price is required")
    .min(0, "Must be greater or equal to 0"),
  barcode: Yup.string().when("isVTEX", {
    is: true,
    then: () =>
      Yup.string().when("hasVariants", {
        is: false,
        then: () =>
          Yup.string()
            .required("Barcode is required")
            .min(5, "Barcode must be at least 5 characters."),
      }),
  }),
  // barcode: Yup.string()
  //   .required("REQUIRED")
  //   .when("isVTEX", {
  //     is: true,
  //     then: () => Yup.string().required("Vtex is required").when('hasVariants',{

  //       is
  //     }),
  //   }),
  vtex_product_id: Yup.string().when("isVTEX", {
    is: true,
    then: () =>
      Yup.string()
        .required("Reference code is required.")
        .min(5, "Reference code must be at least 5 characters."),
  }),
  hs_code: Yup.string(),
  // weight: Yup.number().when("isVTEX", {
  //   is: false,
  //   then: () => Yup.number().min(0, "Must be greater or equal to 0"),
  // }),
  weight: Yup.number().when("isVTEX", {
    is: true,
    then: () =>
      Yup.number()
        .min(0, "Must be greater or equal to 0")
        .required("Weight is required"),
  }),
  volume: Yup.number().when("isVTEX", {
    is: false,
    then: () => Yup.number().min(0, "Must be greater or equal to 0"),
  }),
  list_price: Yup.number().when("isVTEX", {
    is: true,
    then: () =>
      Yup.number()
        .min(0, "Must be greater or equal to 0")
        .required("List Price is Required"),
  }),
  ProHeight: Yup.number().when("isVTEX", {
    is: true,
    then: () =>
      Yup.number()
        .min(0, "Must be greater or equal to 0")
        .required("Height is Required"),
  }),
  ProWidth: Yup.number().when("isVTEX", {
    is: true,
    then: () =>
      Yup.number()
        .min(0, "Must be greater or equal to 0")
        .required("Width is Required"),
  }),
  ProLength: Yup.number().when("isVTEX", {
    is: true,
    then: () =>
      Yup.number()
        .min(0, "Must be greater or equal to 0")
        .required("Length is Required"),
  }),
  sale_delay: Yup.number().min(0, "Must be greater or equal to 0"),
  // description: Yup.string(),
});
export const newProductEcommerceFormValidationSchema = Yup.object({
  ...newProductCommonData,
  public_categ_ids: Yup.array(),
  alternative_product_ids: Yup.array().of(Yup.number()),
});
export const newProductImageFormValidationSchema = Yup.object({
  ...newProductCommonData,
  social_image_1920: Yup.string(),
});

export const newProductFormValidationSchema = (isVTEX) => {
  if (isVTEX) {
    return [
      newProductVTEXFormValidationSchema,
      newProductGeneralFormValidationSchema,
      // newProductEcommerceFormValidationSchema,
      // newProductImageFormValidationSchema,
      Yup.object({}),
      Yup.object({}),
    ];
  } else {
    return [
      newProductGeneralFormValidationSchema,
      newProductEcommerceFormValidationSchema,
      newProductImageFormValidationSchema,
      Yup.object({}),
      Yup.object({}),
      // newProductVTEXFormValidationSchema,
    ];
  }
};
